import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/admin/qairBouns/list',
      data
    });
  },
  getPairs(data) {
    return http.get({
      url: '/admin/tradePair/allDisplay',
      data
    });
  },
  addPairBonus(data) {
    return http.post({
      url: '/admin/qairBouns/addOrUpdate',
      data,
      dataType: 'form'
    });
  }
};
